const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Typography, Grid2, FormControl, TextField, Button } from '@mui/material';
import CustomReactValidator from '../CustomReactValidator';

class ResendVerificationEmailForm extends Component {
    constructor(props) {
        super(props);
        this.state = { username: '' };
        this.validator = new CustomReactValidator();
    }

    handleSend = () => {
        if (this.validator.allValid()) {
            const inputdata = this.state.username;
            this.props.sendEmail(inputdata);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        const { t } = this.props;

        const error = this.props.error ? this.props.error : this.props.model?.error ? this.props.model?.error : '';
        const success = this.props.success ? this.props.success : this.props.model?.success ? this.props.model?.success : '';

        return (
            (<Grid2 container size={12} className="wpvc_login_page" rowSpacing={2}>
                <Grid2 container size={12}>
                    <FormControl fullWidth className="wpvc_form_control">
                        <TextField className="wpvc_text_field" type="text" name="username" label={t("login_username")} onChange={(e) => this.setState({ username: e.target.value })} autoComplete="username" variant='standard' />
                        {this.validator.message(t('username_required'), this.state.username, 'required')}
                        {
                            error != '' &&
                            <Typography className="wpvc_error_login">{error}</Typography>
                        }
                        {
                            success != '' &&
                            <Typography className="wpvc_success_pass">{success}</Typography>
                        }
                    </FormControl>
                </Grid2>
                <Grid2 container size={12} justifyContent="flex-start">
                    <Button
                        variant="contained"
                        className="wpvc_login_btns"
                        color="secondary"
                        onClick={this.handleSend}
                    >{t('send_email')}</Button>
                </Grid2>
                <Grid2 container size={12} justifyContent="flex-start">
                    <Button
                        className="wpvc_forgot_link"
                        color="primary"
                        component="a"
                        onClick={() => { this.props.toggleVerificationEmail(false) }}
                    >
                        {t('back_to_login')}
                    </Button>
                </Grid2>
            </Grid2>)
        );

    }
}

export default connect()(withTranslation("translations")(ResendVerificationEmailForm));
